import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ChangePasswordButton.css';

const ChangePasswordButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to the change password page when the button is clicked
    navigate('/changepassword');
  };

  return (
    <button className="cp-button" onClick={handleClick}>
      Change Password
    </button>
  );
};

export default ChangePasswordButton;
